<template>
  <div>
    <google-marker
      v-for="shop in mapShops"
      :key="shop.id"
      :position="{ lat: shop.latitude, lng: shop.longitude }"
      :icon="iconForShop(shop)"
      @click="shopChanged(shop.id)"
    ></google-marker>
  </div>
</template>
<script>
// import ConvenienceStore from "../assets/markers/convenience-store.svg"
// import Restaurant from "../assets/markers/restaurant.svg"
import IconActive from "../assets/markers/icon-active.svg"
import IconDefault from "../assets/markers/icon-default.svg"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      iconAssignment: {
        // 1: ConvenienceStore,
        // 3: Restaurant,
        default: IconDefault,
        active: IconActive
      }
    }
  },

  methods: {
    shopChanged(shopId) {
      this.$log.debug(shopId)
      this.setHighlightedShopId(shopId)
    },

    iconForShop(shop) {
      // const url =
      // this.iconAssignment[shop.site.category.id] ||
      // this.iconAssignment["default"]
      // const scaled = this.highlightedShopId === shop.id ? 75 : 50
      const url =
        this.highlightedShopId === shop.id
          ? this.iconAssignment.active
          : this.iconAssignment.default

      return {
        // size: { width: scaled, height: scaled },
        // scaledSize: { width: scaled, height: scaled },
        // anchor: { x: scaled / 2, y: scaled },
        url
      }
    },

    ...mapActions("stores", ["setHighlightedShopId"])
  },

  computed: {
    ...mapGetters("stores", ["mapShops", "highlightedShopId"])
  }
}
</script>

<style></style>
